import { render, staticRenderFns } from "./RefridgerationMaintenance.vue?vue&type=template&id=39dfe765&"
import script from "./RefridgerationMaintenance.vue?vue&type=script&lang=js&"
export * from "./RefridgerationMaintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports